import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";

type PermissionInput = string | string[] | undefined | null;

export function usePermission(
  permission?: string,
  options?: { requireAll?: boolean },
) {
  const { user } = useAuth();
  const permissions = user?.permissions ?? [];
  const requireAll = options?.requireAll ?? false;

  return useMemo(() => {
    if (!permission) return true;
    return permissions.includes(permission);
  }, [permission, permissions, requireAll]);
}

export function usePermissions(
  input?: PermissionInput,
  options?: { requireAll?: boolean },
) {
  const { user } = useAuth();
  const permissions = user?.permissions ?? [];
  const requireAll = options?.requireAll ?? false;

  return useMemo(() => {
    if (!input) return true;

    const required = Array.isArray(input) ? input.filter(Boolean) : [input];
    if (required.length === 0) return true;

    return requireAll
      ? required.every((p) => permissions.includes(p))
      : required.some((p) => permissions.includes(p));
  }, [input, permissions, requireAll]);
}
